export const R_OVERVIEW = 'R_OVERVIEW'
export const R_HIRE_DEVELOPER = 'R_HIRE_DEVELOPER'
export const R_UPDATE_DEVELOPER_INFO = 'R_UPDATE_DEVELOPER_INFO'



// WEBPACK FOOTER //
// ./src/config/routing/route-types.js